module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "team-location-upsell-illustration.3964ef43.png" + "?" + Date.now();